import { render } from "./TheCartOrderReceiving.vue?vue&type=template&id=47c4a78a"
import script from "./TheCartOrderReceiving.vue?vue&type=script&lang=js"
export * from "./TheCartOrderReceiving.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__